import { PayloadAction } from "@reduxjs/toolkit";
import { MoneyState } from "../../models/MoneyState";
import { UpdateCategoriesPayload } from "../../payload/UpdateCategories.ts/UpdateCategoriesPayload";

const updateCategoriesFetch = (state: MoneyState, action: PayloadAction<UpdateCategoriesPayload>) => {
    state.isLoading = true;
}

export default updateCategoriesFetch;